module.exports = __webpack_public_path__ + "img/lead.46e12cbb.svg";